export enum ESortOrder {
  Asc = "ASC",
  Desc = "DESC",
}

export type OrderChangeFunction = (order: ESortOrder | undefined) => void;
